import * as gzImgSrc from './img-src.directive';

export default angular.module('gazelle.components.printosImages.imgSrc', [
  'rhino.core'
])
  .directive(gzImgSrc.name, gzImgSrc.default)
  .name;
